export enum FileTypeEnum {
  IMAGE = 'image',
  DOCUMENT = 'document',
  VIDEO = 'video',
  AUDIO = 'audio',
  SITE = 'site',
  OTHER = 'other'
} 